import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";

import { SightSchoolService } from "@services";

import { LearningPathBadgeComponent } from "./learning-path-badge.component";

@NgModule({
	imports: [CommonModule, RouterModule],
	declarations: [LearningPathBadgeComponent],
	exports: [LearningPathBadgeComponent],
	providers: [SightSchoolService]
})
export class LearningPathBadgeModule { }
